import { render, staticRenderFns } from "./guize2.vue?vue&type=template&id=17bf8194&scoped=true&"
var script = {}
import style0 from "./guize2.vue?vue&type=style&index=0&id=17bf8194&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bf8194",
  null
  
)

export default component.exports